import { render } from "./delcategmodal.vue?vue&type=template&id=15888428&scoped=true"
import script from "./delcategmodal.vue?vue&type=script&lang=js"
export * from "./delcategmodal.vue?vue&type=script&lang=js"

import "./delcategmodal.vue?vue&type=style&index=0&id=15888428&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15888428"]])

export default __exports__